/**
 * Id param names seen in widgets that do not follow the widget standard, with the standard id
 * input each stands for. Content Studio widgets read only the params their code asks for, so a
 * served ad cannot check which entity such a widget drew: it may show its sample entity instead.
 */
const STANDARD_NAME_FOR: Record<string, string> = {
  match_id: 'event_sr_id',
  matchId: 'event_sr_id',
  event_id: 'event_sr_id',
  eventId: 'event_sr_id',
  sport_event_id: 'event_sr_id',
  season_id: 'season_sr_id',
  seasonId: 'season_sr_id',
  competition_id: 'competition_sr_id',
  competitionId: 'competition_sr_id',
  tournament_id: 'competition_sr_id',
  competitor_id: 'competitor_sr_id',
  competitorId: 'competitor_sr_id',
  team_id: 'competitor_sr_id',
  teamId: 'competitor_sr_id',
  player_id: 'player_sr_id',
  playerId: 'player_sr_id',
};

export type NonStandardId = { name: string; standardName: string };

/**
 * The known non-standard id params in a widget link that has no standard `*_sr_id` param. A link
 * with a standard id, or one that cannot be read, has none.
 */
export function findNonStandardIds(url: string): NonStandardId[] {
  let names: string[];
  try {
    names = [...new Set(new URL(url).searchParams.keys())];
  } catch {
    return [];
  }
  if (names.some((name) => name.endsWith('_sr_id'))) return [];
  return names
    .filter((name) => Object.prototype.hasOwnProperty.call(STANDARD_NAME_FOR, name))
    .map((name) => ({ name, standardName: STANDARD_NAME_FOR[name] }));
}
